import {
  URL_CESCO,
  URL_COMMUNICATIONS,
  URL_GENERAL_CONDITIONS,
  URL_MARKETING,
  URL_PRIVACY,
  URL_PRIVACY_TINK,
} from './constants';

export const createTransLinksComponents = (
  onClick?: () => void,
  dataTest?: string,
  className?: string,
) => ({
  terms: <a href={URL_GENERAL_CONDITIONS} target="_blank" rel="noopener" />,
  communications: (
    <a href={URL_COMMUNICATIONS} target="_blank" rel="noopener" />
  ),
  marketing: <a href={URL_MARKETING} target="_blank" rel="noopener" />,
  privacy: <a href={URL_PRIVACY} target="_blank" rel="noopener" />,
  cesco: <a href={URL_CESCO} target="_blank" rel="noopener" />,
  a: <a />,
  onClickLink: (
    <a
      className={className}
      data-test={dataTest || 'link-clickable'}
      onClick={onClick}
    />
  ),
  privacyTink: <a href={URL_PRIVACY_TINK} target="_blank" rel="noopener" />,

  bold: <b style={{ fontWeight: 'bold' }} />,
  br: <br />,
});
